import React, { useEffect, useState } from "react";
import { Link, Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";

import SealAndTitle from "./Home/SealAndTitle";
import AttorneyMenu from "./Attorney/AttorneyMenu";
import Welcome from "./Attorney/Welcome";
import Appointment from "./Attorney/Appointment";
import AvailableAppointments from "./Attorney/AvailableAppointmets";
import UpdatePersonalInfo from "./Attorney/UpdatePersonalInfo";
import UpdatePassword from "./Attorney/UpdatePassword";
import Footer from "./Home/Footer";
import userService from '../services/userService';
import courtSeal from "./Home/images/CourtSeal-no-back.png";
import "./Home/style/home.css";

const Attorney = () => {
  const user = useSelector((state) => state.authentication.user);
  useEffect(() => {
    console.log("start");
    const interval = setInterval(() => {
      userService.refreshToken();
    }, 240000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <React.Fragment>
      <Row className="largeHero">
        <Col xs={12} className="opaqueHeroSection">
          <SealAndTitle courtSeal={courtSeal} />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center ">
        {!user.emailConfirmed && (
          <Col xs={10}>
            <Row>
              <Col sm={9} className="psInfo">
                <Row>
                  <Col xs={12}>
                    <h2>Hi {user ? user.firstName : " "}!</h2>
                    <p>
                      Thank you for registering, an email confirmation has been
                      submitted to your email account. You cannot proceed if you
                      do not confirm your email.
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        )}
        {user.emailConfirmed && (
          <Col xs={10}>
            <Row>
              <Col sm={9} className="psInfo">
                <Switch>
                  <Route path="/attorney/upcomingAppointments">
                    <Appointment />
                  </Route>
                  <Route path="/attorney/availableAppointments">
                    <AvailableAppointments />
                  </Route>
                  <Route path="/attorney/updatePersonalInfo">
                    <UpdatePersonalInfo />
                  </Route>
                  <Route path="/attorney/updatePassword">
                    <UpdatePassword />
                  </Route>
                  <Route path="/attorney">
                    <Welcome />
                  </Route>
                </Switch>
              </Col>
              <Col sm={3} className="litigantMenu">
                <AttorneyMenu />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <Row className="d-flex justify-content-center">
        <Col xs={12}>
          <Footer ScrollLink={Link} psInfo={false} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Attorney;
